import axios from 'axios'

// Get all Signatures
const getAll = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/Signature/all`)
  return data
}

// Update Signature
const update = async (id, price, period, newProduct, nextDate, active) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/Signature/${id}`, {
    price,
    period,
    newProduct,
    nextDate,
    active
  })
  return data
}

export {
  getAll,
  update
}
